import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import ModalContext from 'contexts/ModalContext'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import CarHireInsuranceModal from './CarHireInsuranceUpgradeModal/CarHireInsuranceModal'
import Clickable from 'components/Common/Clickable'

interface Props {
  isEnhancedProtectionSelected: boolean
  offer: App.CarHireOffer
  pickUpDate: string
  dropOffDate: string
}

function CarHireInsuranceText(props: Props) {
  const { isEnhancedProtectionSelected, offer, pickUpDate, dropOffDate } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const onTextClick = () => {
    showModal(<CarHireInsuranceModal isEnhancedProtectionSelected={isEnhancedProtectionSelected} pickUpDate={pickUpDate} dropOffDate={dropOffDate} offer={offer} />)
  }

  const enhancedProtectionLabel = intl.formatMessage({
    id: 'E57eJrRrIuixOy5pJNPC',
    defaultMessage: 'Enhanced Protection',
    description: 'Label for enhanced protection insurance option on car hire',
  })
  const limitedProtectionLabel = intl.formatMessage({
    id: 'N5PaB-0j25fyGOlfKAEH',
    defaultMessage: 'Limited Protection',
    description: 'Label for limited protection insurance option on car hire',
  })

  return <Clickable onClick={onTextClick}>
    <BodyTextBlock
      variant="medium"
      colour={isEnhancedProtectionSelected ? 'highlight-primary-dark' : 'primary'}
      weight="bold"
      endIcon={<LineInfoCircleIcon colour="normal-contrast" size="XS" />}
    >
      {isEnhancedProtectionSelected ? enhancedProtectionLabel : limitedProtectionLabel}
    </BodyTextBlock>
  </Clickable>
}

export default CarHireInsuranceText
